'use client'

import { useRef } from 'react'

/**
 * Creates a stable reference for a value
 */
export function useStableReference<T>(value: T): T {
    const result = useRef<T>(value)

    result.current = value

    return result.current
}
